
import { encryptPassword } from '@/util/encryption'
import { Component, Vue } from 'vue-property-decorator'
import { Store } from 'vuex'

interface ScopeMap {
  [key: string]: string
}

const scopeMap: ScopeMap = {
  user: '用户信息',
  enterprice: '企业信息'
}

interface Options {
  label: string
  value: string
  [propName: string]: any
}

@Component
export default class AccessControl extends Vue {
  $refs!: {
    form: any
  }
  $store!: Store<VuexState>
  isShowPassword: Boolean = false
  account = ''
  password = ''
  errorMsg: String = ''
  isLogging: Boolean = false
  check = ['allScope']
  options: Array<Options> = [{ label: '获得您的账号名称、头像、绑定手机号码、邮箱', value: 'allScope' }]
  // eslint-disable-next-line no-magic-numbers
  currentYear: number = 2018
  isLoading: Boolean = false
  useOtherAccount: Boolean = false

  get isOAuthLogin() {
    return this.$route.path === '/o/oauth2/login'
  }

  get clientName() {
    return this.$route.query.client_name
  }

  get username() {
    return this.$route.query.username
  }

  get currentUsername() {
    return this.$store.state.userData ? this.$store.state.userData.userName : ''
  }

  get errorInput() {
    let value = ''
    switch (this.errorMsg) {
      case '账号不能为空':
        value = 'user'
        break
      case '密码不能为空':
        value = 'password'
        break
      case '':
        value = ''
        break
      default:
        value = 'all'
        break
    }
    return value
  }

  mounted() {
    if (this.isOAuthLogin) {
      const { client_id, scope, client_name, redirect_uri, response_type } = this.$route.query
      if (!(client_id && scope && client_name && redirect_uri && response_type)) {
        this.$router.push({ name: 'Error' })
      }
    } else {
      const { client_id, scope, client_name, redirect_uri, response_type, username } = this.$route.query
      if (!(client_id && scope && client_name && redirect_uri && response_type && username)) {
        this.$router.push({ name: 'Error' })
      }
    }
    this.currentYear = new Date().getFullYear()
  }

  changeIcon() {
    this.isShowPassword = !this.isShowPassword
  }

  validateAccount() {
    if (!this.account.trim()) {
      this.errorMsg = '账号不能为空'
    } else {
      this.errorMsg = ''
    }
  }

  validatePassword() {
    if (!this.password.trim()) {
      this.errorMsg = '密码不能为空'
    } else {
      this.errorMsg = ''
    }
  }

  _authorize() {
    const url = new URL(location.href)
    url.searchParams.delete('selectedUser')
    location.replace(`/oauth/authorize?${url.searchParams}`)
  }

  handleSelect() {
    this._authorize()
  }

  async handleLogin() {
    if (!this.account.trim()) {
      this.errorMsg = '账号不能为空'
      return
    }
    if (!this.password.trim()) {
      this.errorMsg = '密码不能为空'
      return
    }
    if (!this.isLogging) {
      this.errorMsg = ''
      this.isLogging = true
      try {
        const password = await encryptPassword(this, this.password)
        await this.$ucProxy({
          url: '/user/login',
          type: 'POST',
          data: {
            username: this.account,
            password,
          }
        })
        this._authorize()
      } catch (error: any) {
        // eslint-disable-next-line no-magic-numbers
        if (error.code === 2001) {
          this.errorMsg = '账号或密码错误'
        } else {
          this.errorMsg = error.message
        }
      }
      this.isLogging = false
    }
  }

  async handleAuthorize() {
    const authorizeForm = document.createElement('form')
    document.body.appendChild(authorizeForm)
    authorizeForm.method = 'post'
    authorizeForm.action = '/oauth/authorize'
    const userElement = document.createElement('input')
    userElement.setAttribute('name', 'user_oauth_approval')
    userElement.setAttribute('value', 'true')
    authorizeForm.appendChild(userElement)

    const authorizeElement = document.createElement('input')
    authorizeElement.setAttribute('name', 'authorize')
    authorizeElement.setAttribute('value', 'Authorize')
    authorizeForm.appendChild(authorizeElement)

    const scopeElement = document.createElement('input')
    scopeElement.setAttribute('name', `scope.${this.$route.query.scope}`)
    scopeElement.setAttribute('value', 'true')
    authorizeForm.appendChild(scopeElement)

    authorizeForm.submit()
    document.body.removeChild(authorizeForm)
  }
}
